// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ta-qN","title":"AfterBackImages_title__29rZN","images":"AfterBackImages_images__3LddG"};